import { useState } from 'react';
import { omit } from 'lodash';

const Validations = (fields, callback) => {
  const [values, setValues] = useState(fields);
  const [errors, setErrors] = useState({});

  const handleChange = (event) => {
    event.persist();
    const name = event.target.name;
    const value = event.target.value;
    changeValidate(name, value);
    setValues({ ...values, [name]: value });
  };

  // -------------------------------------------------------------------------
  // Live (as-you-type) checks — only rules that make sense mid-typing
  // -------------------------------------------------------------------------
  const changeValidate = (name, value) => {
    switch (name) {
      case 'ownerName':
        if (value !== '' && !/^[a-zA-Z\s.]+$/.test(value)) {
          setErrors({ ...errors, ownerName: 'Letters, spaces and dots only.' });
        } else {
          setErrors(omit(errors, 'ownerName'));
        }
        break;

      case 'shopName':
        if (value !== '' && value.trim().length < 2) {
          setErrors({ ...errors, shopName: 'Shop name is too short.' });
        } else {
          setErrors(omit(errors, 'shopName'));
        }
        break;

      case 'mobile':
        if (value !== '' && !/^[0-9]+$/.test(value)) {
          setErrors({ ...errors, mobile: 'Mobile number should be digits only.' });
        } else {
          setErrors(omit(errors, 'mobile'));
        }
        break;

      case 'shopPincode':
        if (value !== '' && !/^[0-9]+$/.test(value)) {
          setErrors({ ...errors, shopPincode: 'Pincode should be digits only.' });
        } else {
          setErrors(omit(errors, 'shopPincode'));
        }
        break;

      default:
        break;
    }
  };

  // -------------------------------------------------------------------------
  // Full submit-time validation — every field that has a rule
  // -------------------------------------------------------------------------
  const submitValidate = (values) => {
    const subErrors = {};

    if (values.shopName !== undefined) {
      if (!values.shopName.trim()) subErrors.shopName = 'Please enter the shop name.';
      else if (values.shopName.trim().length < 2) subErrors.shopName = 'Shop name is too short.';
      else if (values.shopName.trim().length > 50) subErrors.shopName = 'Shop name is too long (max 50).';
    }

    if (values.category !== undefined) {
      if (!values.category) subErrors.category = 'Please select a category.';
    }

    if (values.ownerName !== undefined) {
      if (!values.ownerName.trim()) subErrors.ownerName = 'Please enter the owner name.';
      else if (!/^[a-zA-Z\s.]+$/.test(values.ownerName))
        subErrors.ownerName = 'Owner name can only contain letters, spaces and dots.';
    }

    if (values.mobile !== undefined) {
			if (values.mobile.trim().length === 0) {
				subErrors.mobile = 'please enter the mobile no.';
			} else if (!/^[0-9]+$/.test(values.mobile)) {
				subErrors.mobile = 'mobile no should be numbers.';
			} else if (values.mobile.trim().length !== 10) {
				subErrors.mobile = 'mobile no should be exact 10 digits.';
			} else if (!/^[6-9]/.test(values.mobile)) {
				subErrors.mobile = 'mobile no should start with 6, 7, 8 or 9.';
			}
		}

    if (values.password !== undefined) {
      if (!values.password.trim()) subErrors.password = 'Please enter the password.';
      else if (values.password.trim().length < 8) subErrors.password = 'Password must be at least 8 characters.';
    }

    if (values.confirmPassword !== undefined) {
      if (!values.confirmPassword.trim()) subErrors.confirmPassword = 'Please confirm the password.';
      else if (values.confirmPassword !== values.password)
        subErrors.confirmPassword = 'Passwords do not match.';
    }

    if (values.shopPincode !== undefined) {
      if (!values.shopPincode.trim()) subErrors.shopPincode = 'Please enter the shop pincode.';
      else if (!/^[0-9]{6}$/.test(values.shopPincode)) subErrors.shopPincode = 'Pincode must be 6 digits.';
    }

    if (values.shopAddress !== undefined) {
      if (!values.shopAddress.trim()) subErrors.shopAddress = 'Please enter the shop address.';
      else if (values.shopAddress.trim().length < 5) subErrors.shopAddress = 'Address is too short.';
    }

    setErrors(subErrors);
    return subErrors;
  };

  // -------------------------------------------------------------------------
  // Submit handler
  // -------------------------------------------------------------------------
  const handleSubmit = async (event) => {
    if (event) event.preventDefault();

    const res = submitValidate(values);

    // Only fire callback if nothing failed
    if (Object.keys(res).length === 0) {
      callback();
    }
  };

  return { values, errors, handleSubmit, handleChange };
};

export default Validations;